<!-- 更改企业名称弹窗 -->
<template>
  <el-dialog v-bind="$attrs">
    <p style="margin-bottom:1vh;">当前企业信息：{{UserForm.name}}</p>
    <el-form ref="changeNameRef" label-width="100px" size="small" class="user-form-sty" :model="accountForm" :rules="accountRules">
      <el-form-item label="新企业名称：" prop="name">
        <div class="item-box">
          <el-input v-model="accountForm.name" placeholder="请输入新企业名称"></el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item label="新密码：" prop="password">
        <div class="item-box">
          <el-input show-password v-model="accountForm.password" placeholder="请输入新密码"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPWD">
        <div class="item-box">
          <el-input show-password v-model="accountForm.confirmPWD" placeholder="请确认密码"></el-input>
        </div>
      </el-form-item> -->
    </el-form>
    <p style="color:#ec1c1c">请确保更改的名称与工商变更后的企业名称完全一致</p>
    <p><span style="color:#ec1c1c">注：</span>如因信息变更出现数据异常，以及后续所产生的一切法律责任均由您自行承担。</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible',false)">取 消</el-button>
      <el-button type="primary" @click="changeNameHand">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {ApiMethods} from "@/assets/js/http-serve/http-methods";
import {password,enterpriseName} from "@/assets/js/lib/valid-methods";
  export default {
    props:{ UserForm:{type:Object,default:{}},checkPwd:{type:String,default:''} }  ,
    data () {
      // 这里存放数据
      return {
        accountForm:{
          name:'',
          password:'',
          confirmPWD:''
        },
        accountRules:{
          name:[{validator: enterpriseName, trigger: "change" }],
          password:[{validator: password, trigger: "change" }],
          confirmPWD:[{validator: this.confirmPWDVer, trigger: "change" }],
        },
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      /** 变更企业名称 */
      changeNameHand(){
        const _this = this;
        _this.$refs.changeNameRef.validate(vaild=>{
          if(!vaild) return
          const {name} = _this.accountForm
          ApiMethods.accountCenter.changeNameAccount({name,password:this.checkPwd}).then(res=>{
            if(!res.success) return this.$message.error(res.description)
            _this.updateCertInfo();
          })
        })
      },
      /** 是否更新证书 */
      updateCertInfo(){
        const _this = this;
        _this.$confirm(
          '<p style="font-size: 16px;">您的企业名称已变更，当前持有的数字证书以注销，是否立即申请新证书？</p>',
          {
            title:'证书申请',
            distinguishCancelAndClose: true,
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即申请",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          _this.$emit('certRenewal')
        }).catch(() => {
          setTimeout(() => {
            _this.$emit('checkUserStatus')
          }, 5 * 1000)
        }).finally(()=>{;
          _this.$emit('update:checkPwd','')
          _this.$emit('update:visible',false)
          _this.$refs.changeNameRef.resetFields()
        });
      },
      // 企业变更弹窗确认密码校验
      confirmPWDVer(rule,value,callback){
        if (!value || value === '') {
          return callback('请输入确认密码')
        }
        if (value === this.accountForm.password) {
          return callback()
        }
        return callback('确认密码与新密码不一致')
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
</style>


// WEBPACK FOOTER //
// pages/tpl/components/accountInfo/popups/changeAccount.vue